import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, browserLocalPersistence, setPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
// Persistencia local: la sesión sobrevive cierres de navegador (no pide login cada vez).
// El tope efectivo de 30 días lo aplica AuthGate (re-loguea si lastSignInTime es más viejo).
setPersistence(auth, browserLocalPersistence).catch((e) => console.error("persistence", e));
export const db = getFirestore(app);
// Cloud Functions del proyecto (login por código vive en us-central1, el default).
export const functions = getFunctions(app);
export const googleProvider = new GoogleAuthProvider();

// Aislamiento total: todo el feature de la clase vive acá.
export const WHITELIST_COLLECTION = "finanzas_class_whitelist";
export const VIDEOS_COLLECTION = "finanzas_videos";
export const VIDEOS_DOC_ID = "main";
export const TEXTS_COLLECTION = "finanzas_texts";
export const TEXTS_DOC_ID = "main";
export const ADMIN_EMAIL = "hhelmanj@gmail.com";

// Textos explicativos por defecto para cada tab. Soportan HTML.
// Si admin los edita en Firestore (finanzas_texts/main), se usa el override.
export const DEFAULT_TAB_TEXTS = {
  curva: `<p>Antes de calcular costos y márgenes, hay que entender algo: <strong>los precios los pone el mercado, no vos</strong>.</p>
<p>Acá vas a ver cómo se cruzan la oferta (lo que los productores quieren vender) y la demanda (lo que los consumidores quieren pagar). El punto donde se cruzan es el <strong>precio de equilibrio</strong>.</p>
<p>Si ponés un precio más alto, te va a sobrar mercadería. Si lo ponés más bajo, te va a faltar producto.</p>`,

  formulas: `<p>Acá vas a entender la diferencia entre <strong>margen y markup</strong> — dos formas de calcular el precio que parecen iguales pero NO LO SON.</p>
<p>Muchos emprendedores piden 30% de margen y por confundir las fórmulas terminan con 23%. Es el error más caro y más común.</p>
<p>Vas a aprender la fórmula correcta para que el % que pedís sea el % que efectivamente ganás.</p>`,

  fc: `<p>El <strong>food cost</strong> es cuánto te cuesta producir UNA unidad de tu producto. Es la base de todo el costeo.</p>
<p>Podés calcularlo de dos formas:</p>
<ul>
<li><strong>Modo Simple:</strong> ingresás directamente el costo</li>
<li><strong>Modo Receta:</strong> lo construís desde los ingredientes</li>
</ul>
<p>El modo receta te permite <strong>guardar tus recetas en la nube</strong> y exportarlas a Excel con fórmulas listas para editar.</p>`,

  pe: `<p>El <strong>Punto de Equilibrio (PE)</strong> es la cantidad mínima que tenés que vender para no perder plata.</p>
<p>Es decir: cubrir todos los costos sin ganar ni perder. A partir de esa cantidad, todo lo que vendas es ganancia.</p>
<p>Es la primera meta del negocio: <strong>superar el PE mes a mes</strong>. Si no llegás al PE consistentemente, el negocio se sostiene de tu bolsillo (o cierra).</p>`,

  eerr: `<p>El <strong>Estado de Resultados (EERR)</strong> es la foto mensual de cómo le fue al negocio.</p>
<p>Te muestra:</p>
<ul>
<li>Cuánta plata entró (<strong>ingresos</strong>)</li>
<li>Cuánta plata salió (<strong>costos y gastos</strong>)</li>
<li>Cuánta plata te quedó (<strong>resultado</strong>)</li>
</ul>
<p>Podés armar tu propio EERR con categorías de gastos personalizables y exportarlo a Excel con fórmulas para usarlo todos los meses como template.</p>`,

  cf: `<p>Mientras que el EERR mira la <strong>rentabilidad</strong> (¿gano o pierdo?), el Flujo de Caja mira la <strong>liquidez</strong> (¿tengo plata cuando la necesito?).</p>
<p>Podés ser rentable y aun así quebrar si no tenés plata para pagar los sueldos del mes. Por eso hay que mirar las dos cosas.</p>
<p>Acá registrás ingresos y egresos diarios y ves cómo evoluciona tu saldo. También exportable a Excel.</p>`,

  bal: `<p>El <strong>balance</strong> es la foto patrimonial del negocio en un momento específico:</p>
<ul>
<li><strong>Activos:</strong> lo que tenés</li>
<li><strong>Pasivos:</strong> lo que debés</li>
<li><strong>Patrimonio:</strong> la diferencia</li>
</ul>
<p>Es lo último que se entiende porque es lo más abstracto. Pero la regla es simple y siempre se cumple: <strong>Activos = Pasivos + Patrimonio</strong>.</p>
<p>Acá registrás movimientos y la balanza se mantiene equilibrada sola.</p>`,
};

// Tabs de la app — usado por el Admin para gestionar videos/textos por sección.
export const FINANZAS_TABS = [
  { key: "curva", label: "Precios" },
  { key: "formulas", label: "Fórmulas" },
  { key: "fc", label: "Food Cost" },
  { key: "pe", label: "Pto. Equilibrio" },
  { key: "eerr", label: "EERR" },
  { key: "cf", label: "Flujo Caja" },
  { key: "bal", label: "Balance" },
];
